







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';


@Component({
  components: { AdminIframe, PageTitle },
})
export default class AdminListIframe extends Vue {
  private title = '운영자 관리';
  private remoteSrc = '';

  private setRemoteSrc() {
    const { params: { role }, query } = this.$route;
    const queryString = new URLSearchParams({ ...query, serviceType: 'PREMIUM' }).toString();
    const menuSegment = role ? 'role' : 'admin';
    const roleSegment = role ? `/${role}` : '';
    this.remoteSrc =
      process.env.VUE_APP_ADMIN_REMOTE_URL + `/configuration/management/${menuSegment}${roleSegment}?${queryString}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
